export { default } from './CheckBox';


// WEBPACK FOOTER //
// ./src/components/shared/CheckBox/index.ts